import { render } from "./HardwareHome.vue?vue&type=template&id=af0caa84&scoped=true"
import script from "./HardwareHome.vue?vue&type=script&lang=js"
export * from "./HardwareHome.vue?vue&type=script&lang=js"

import "./HardwareHome.vue?vue&type=style&index=0&id=af0caa84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af0caa84"]])

export default __exports__